export const companiesClientContext = {
  delete: '',
  update: '/user-service/api/external/companies/{id}',
  add: '/user-service/api/external/companies',
  getAll: '/user-service/api/external/companies',
  get: '/user-service/api/external/companies/{id}',
  updateLogo: '/user-service/api/external/companies/{id}/logo',
  register: '/user-service/api/external/companies/registartion',
  fieldsStructure: '/user-service/api/external/fieldsStructure',
  companyMembers: '/user-service/api/external/companies/{id}/members',
  withdraw: '/user-service/api/external/companies/{id}/withdrawCheck',
  self: {
    updateImages: '/user-service/api/external/companies/self/images',
    updateLogo: '/user-service/api/external/companies/self/logo',
    updateAvatar: '/user-service/api/external/users/self/avatar',
    all: '/user-service/api/external/companies/self',
  },
  image: {
    uploadImage: '/user-service/api/external/companies/{id}/image',
    updateImage: '/user-service/api/external/companies/{id}/image/{imageId}',
    reorganizeImage: '/user-service/api/external/companies/{id}/image/{imageId}/order',
    deleteImage: '/user-service/api/external/companies/{id}/image/{imageId}',
  },
  seller: {
    create: '/user-service/api/external/legalSellers',
    memberById: '/user-service/api/external/legalSellers/members/{id}',
    memberStatus: '/user-service/api/external/legalSellers/members/{id}/status',
    inviteMember: '/user-service/api/external/legalSellers/{id}/member/invite',
    createMemberFromUser: '/user-service/api/external/legalSellers/{id}/member/fromUser',
    statistics: '/web-api/sellerOrders/{id}/statistics',
    status: '/user-service/api/external/legalSellers/{id}/status',
    update: '/user-service/api/external/legalSellers/{id}',
  },
  buyer: {
    create: '/user-service/api/external/legalBuyers',
    getById: '/user-service/api/external/legalBuyers/{id}',
    memberById: '/user-service/api/external/legalBuyers/members/{id}',
    memberStatus: '/user-service/api/external/legalBuyers/members/{id}/status',
    invite: '/user-service/api/external/legalBuyers/{id}/member/invite',
    createMemberFromUser: '/user-service/api/external/legalBuyers/{id}/member/fromUser',
    status: '/user-service/api/external/legalBuyers/{id}/status',
  },
  agents: {
    create: '/user-service/api/external/legalAgents',
    getById: '/user-service/api/external/legalAgents/{id}',
    memberById: '/user-service/api/external/legalAgents/members/{id}',
    memberStatus: '/user-service/api/external/legalAgents/members/{id}/status',
    inviteMember: '/user-service/api/external/legalAgents/{id}/member/invite',
    createMemberFromUser: '/user-service/api/external/legalAgents/{id}/member/fromUser',
    status: '/user-service/api/external/legalAgents/{id}/status',
  },
};
